import React from 'react';
import './SuccessRegister.css';

interface Props extends React.SVGProps<SVGSVGElement> {
  title: string;
}

function SuccessRegister({ title, ...svgProps }: Props): JSX.Element {
  return (
    <svg
      id="tudocerto"
      width="200"
      height="160"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 160"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      {...svgProps}
    >
      <title>{title}</title>
      <defs>
        <linearGradient
          id="tudocerto-union-fill"
          x1="144.500000"
          y1="114"
          x2="103.718000"
          y2="10.540900"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            id="tudocerto-union-fill-0"
            offset="0%"
            stopColor="rgb(74,164,242)"
          />
          <stop
            id="tudocerto-union-fill-1"
            offset="100%"
            stopColor="rgb(34,114,204)"
          />
        </linearGradient>
        <linearGradient
          id="tudocerto-circle1-fill"
          x1="48"
          y1="0"
          x2="-7.335160"
          y2="37.042500"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            id="tudocerto-circle1-fill-0"
            offset="0%"
            stopColor="rgb(255,255,255)"
          />
          <stop
            id="tudocerto-circle1-fill-1"
            offset="100%"
            stopColor="rgb(160,207,248)"
          />
        </linearGradient>
        <linearGradient
          id="tudocerto-vector-71-stroke-fill"
          x1="110.588000"
          y1="103.941000"
          x2="114.900000"
          y2="124.160000"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            id="tudocerto-vector-71-stroke-fill-0"
            offset="0%"
            stopColor="rgb(74,164,242)"
          />
          <stop
            id="tudocerto-vector-71-stroke-fill-1"
            offset="100%"
            stopColor="rgb(34,114,204)"
          />
        </linearGradient>
        <linearGradient
          id="tudocerto-subtract_3-fill"
          x1="154"
          y1="46"
          x2="55"
          y2="52.500000"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            id="tudocerto-subtract_3-fill-0"
            offset="0%"
            stopColor="rgb(246,250,254)"
          />
          <stop
            id="tudocerto-subtract_3-fill-1"
            offset="100%"
            stopColor="rgb(214,239,254)"
          />
        </linearGradient>
      </defs>
      <g id="tudocerto-tudocerto_tr" transform="translate(100,80) rotate(-20)">
        <g id="tudocerto-tudocerto" transform="translate(-100,-80)">
          <rect
            id="tudocerto-rect1"
            width="200"
            height="160"
            rx="0"
            ry="0"
            fill="rgb(255,255,255)"
            stroke="none"
            strokeWidth="1"
          />
          <path
            id="tudocerto-union"
            d="M39,34C39,29.581700,42.581700,26,47,26L152,26C156.418000,26,160,29.581700,160,34L160,51C160,51,158.500000,44,154,44C154,42.277200,154,42.731400,154,38C154,33.268600,150.217000,30,146,30L57,30C52.581700,30,49,33.581700,49,38L49,43L152,43C156.418000,43,160,46.581700,160,51L160,109C160,113.418000,156.418000,117,152,117L47,117C42.581700,117,39,113.418000,39,109L39,34Z"
            fill="url(#tudocerto-union-fill)"
            stroke="none"
            strokeWidth="1"
          />
          <g id="tudocerto-check_ts" transform="translate(124,111) scale(0,0)">
            <g id="tudocerto-check" transform="translate(-124,-111)">
              <g id="tudocerto-ellipse-79">
                <circle
                  id="tudocerto-circle1"
                  r="24"
                  transform="matrix(-1 0 0 1 124 111)"
                  fill="url(#tudocerto-circle1-fill)"
                  stroke="none"
                  strokeWidth="1"
                />
              </g>
              <path
                id="tudocerto-vector-71-stroke"
                d="M136.243000,104.308000C136.820000,104.833000,136.863000,105.726000,136.338000,106.303000L122.221000,121.832000C121.949000,122.131000,121.563000,122.299000,121.159000,122.294000C120.756000,122.289000,120.374000,122.112000,120.109000,121.807000L110.933000,111.219000C110.422000,110.630000,110.486000,109.738000,111.075000,109.227000C111.664000,108.717000,112.556000,108.780000,113.067000,109.370000L121.201000,118.756000L134.249000,104.403000C134.774000,103.826000,135.667000,103.784000,136.243000,104.308000Z"
                clipRule="evenodd"
                fill="url(#tudocerto-vector-71-stroke-fill)"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
              />
            </g>
          </g>
          <path
            id="tudocerto-costura"
            d="M53.060600,50.500000C53.060600,51.328400,52.389000,52,51.560600,52L51.500000,52C50.671600,52,50,51.328400,50,50.500000C50,49.671600,50.671600,49,51.500000,49L51.560600,49C52.389000,49,53.060600,49.671600,53.060600,50.500000ZM64.282800,50.500000C64.282800,51.328400,63.611300,52,62.782800,52L59.661600,52C58.833200,52,58.161600,51.328400,58.161600,50.500000C58.161600,49.671600,58.833200,49,59.661600,49L62.782800,49C63.611300,49,64.282800,49.671600,64.282800,50.500000ZM75.505000,50.500000C75.505000,51.328400,74.833500,52,74.005100,52L70.883800,52C70.055400,52,69.383800,51.328400,69.383800,50.500000C69.383800,49.671600,70.055400,49,70.883800,49L74.005000,49C74.833500,49,75.505000,49.671600,75.505000,50.500000ZM86.727300,50.500000C86.727300,51.328400,86.055700,52,85.227300,52L82.106100,52C81.277600,52,80.606100,51.328400,80.606100,50.500000C80.606100,49.671600,81.277600,49,82.106100,49L85.227300,49C86.055700,49,86.727300,49.671600,86.727300,50.500000ZM97.949500,50.500000C97.949500,51.328400,97.277900,52,96.449500,52L93.328300,52C92.499900,52,91.828300,51.328400,91.828300,50.500000C91.828300,49.671600,92.499900,49,93.328300,49L96.449500,49C97.277900,49,97.949500,49.671600,97.949500,50.500000ZM109.172000,50.500000C109.172000,51.328400,108.500000,52,107.672000,52L104.551000,52C103.722000,52,103.051000,51.328400,103.051000,50.500000C103.051000,49.671600,103.722000,49,104.551000,49L107.672000,49C108.500000,49,109.172000,49.671600,109.172000,50.500000ZM120.394000,50.500000C120.394000,51.328400,119.722000,52,118.894000,52L115.773000,52C114.944000,52,114.273000,51.328400,114.273000,50.500000C114.273000,49.671600,114.944000,49,115.773000,49L118.894000,49C119.722000,49,120.394000,49.671600,120.394000,50.500000ZM131.616000,50.500000C131.616000,51.328400,130.945000,52,130.116000,52L126.995000,52C126.167000,52,125.495000,51.328400,125.495000,50.500000C125.495000,49.671600,126.167000,49,126.995000,49L130.116000,49C130.945000,49,131.616000,49.671600,131.616000,50.500000ZM142.838000,50.500000C142.838000,51.328400,142.167000,52,141.338000,52L138.217000,52C137.389000,52,136.717000,51.328400,136.717000,50.500000C136.717000,49.671600,137.389000,49,138.217000,49L141.338000,49C142.167000,49,142.838000,49.671600,142.838000,50.500000ZM151,50.500000C151,51.328400,150.328000,52,149.500000,52L149.439000,52C148.611000,52,147.939000,51.328400,147.939000,50.500000C147.939000,49.671600,148.611000,49,149.439000,49L149.500000,49C150.328000,49,151,49.671600,151,50.500000Z"
            clipRule="evenodd"
            fill="rgb(36,116,206)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          />
          <g
            id="tudocerto-subtract_to"
            transform="translate(101.500000,36.500000)"
          >
            <path
              id="tudocerto-subtract"
              d="M57,30C52.581700,30,49,33.581700,49,38L49,43L154,43L154,38C154,33.581700,150.418000,30,146,30L57,30Z"
              transform="translate(-101.500000,-36.500000)"
              fill="rgb(224,239,253)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="tudocerto-subtract_2_to" transform="translate(101.500000,38)">
            <g id="tudocerto-subtract_2_ts" transform="scale(1,1)">
              <path
                id="tudocerto-subtract_2"
                d="M57,33C52.581700,33,49,36.581700,49,41L49,43L154,43L154,41C154,36.581700,150.418000,33,146,33L57,33Z"
                transform="translate(-101.500000,-38)"
                fill="rgb(124,189,247)"
                stroke="none"
                strokeWidth="1"
              />
            </g>
          </g>
          <g id="tudocerto-subtract_3_to" transform="translate(101.500000,40)">
            <g id="tudocerto-subtract_3_ts" transform="scale(1,1)">
              <path
                id="tudocerto-subtract_3"
                d="M49.252000,43L153.748000,43C152.860000,39.549500,149.728000,37,146,37L56.999900,37C53.272200,37,50.140000,39.549500,49.252000,43Z"
                transform="translate(-101.500000,-40)"
                fill="url(#tudocerto-subtract_3-fill)"
                stroke="none"
                strokeWidth="1"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default React.memo(SuccessRegister);
